import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Organisation, PatchOrganisation } from 'src/types/shared/Organisation';
import {
    getOrganisationIsPatching,
    getOrganisationPatchError,
    getOrganisationPatchSuccess,
} from '@selectors/organisation';
import useForm from '@components/form/hooks/useForm';
import usePrevious from 'lib/src/hooks/usePrevious';
import { patchOrganisation } from '@actions/assessments';
import { useParams } from 'react-router';

interface Params {
    id: string;
}

const useEditOrganisationForm = (organisation: Organisation, onSuccess: () => void) => {
    const { id } = useParams<Params>();
    const dispatch = useDispatch();
    const isPatching = useSelector(getOrganisationIsPatching);
    const patchSuccess = useSelector(getOrganisationPatchSuccess);
    const patchError = useSelector(getOrganisationPatchError);

    const [data, handleChange] = useForm<PatchOrganisation>({
        submissionId: organisation.submissionId,
        ktnEntrySummary: organisation.ktnEntrySummary ?? '',
        organisationSize: organisation.organisationSize,
        organisationType: organisation.organisationType,
    });

    const prevPatchSuccess = usePrevious(patchSuccess);
    useEffect(() => {
        if (!prevPatchSuccess && patchSuccess) onSuccess();
    }, [patchSuccess, prevPatchSuccess, onSuccess]);

    const handleSubmit = () => {
        dispatch(patchOrganisation(data, parseInt(id)));
    };

    return { data, handleChange, handleSubmit, isPatching, patchSuccess, patchError };
};

export default useEditOrganisationForm;
